import React, { useMemo } from 'react';
import { Checkbox } from '@material-ui/core';
import every from 'lodash/every';
import includes from 'lodash/includes';
import CustomMuiDropdown from '../../../../../../../../components/CustomMuiDropdown/CustomMuiDropdown';

import s from './TagsFilter.module.css';
import MLIcon from '../../../../../../../../components/MLIcon/MLIcon';

const createTagLabels = (data, tags, selectedTags) => {
  const allTags = [...tags, 'No challenges'];

  const selectedOptions = data.flatMap((record) => {
    const answers = [record.answer_0, record.answer_1];

    return answers.flatMap((answer) => {
      if (!answer || answer === '--' || /^n\/a$/i.test(answer)) {
        return [];
      }

      if (answer === 'No challenges') {
        return ['No challenges'];
      }

      if (Array.isArray(answer)) {
        return answer.filter((item) => allTags.includes(item));
      }

      if (typeof answer === 'string') {
        return allTags.includes(answer) ? [answer] : [];
      }

      return [];
    });
  });

  const counts = selectedOptions.reduce((acc, option) => {
    acc[option] = (acc[option] || 0) + 1;
    return acc;
  }, {});

  return allTags.map((option) => {
    const num = counts[option] || 0;
    const label = `${option} (${num})`;

    return {
      label: (
        <div className={s.tagOption}>
          <Checkbox checked={includes(selectedTags, option)} />
          <span>{label}</span>
        </div>
      ),
      value: option,
    };
  });
};

function TagsFilter({ selectedTags, setSelectedTags, data }) {
  const tagOptions = every([data.tagOptions], Boolean) && data.tagOptions;
  const tagLabels = useMemo(() => createTagLabels(
    data.data,
    tagOptions,
    selectedTags
  ), [data.data, tagOptions, selectedTags]);

  const selected = Boolean(selectedTags?.length);

  const handleOptionClick = (o) => {
    if (includes(selectedTags, o.value)) {
      setSelectedTags((tags) => tags.filter((tag) => tag !== o.value));
    } else {
      setSelectedTags([...selectedTags, o.value]);
    }
  };

  return (
    <div className={s.dropdownContainer}>
      <CustomMuiDropdown
        title={
          <div
            className={`${s.buttonLabel} ${selected && s.buttonLabelSelected}`}
          >
            <MLIcon
              className={s.filterMenuIcon}
              role="presentation"
              type="filterMenu"
              viewBox="0 0 14 14"
              height={14}
              width={14}
            />
            <span className={s.labelName}>
              Filter Challenges {selected && `(${selectedTags?.length})`}
            </span>
          </div>
        }
        isMenu
        onClickItem={handleOptionClick}
        className={`${s.tagsFilterButton} ${
          selected && s.tagsFilterButtonSelected
        }`}
        optionsClassName={s.tagOptions}
        items={tagLabels}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        keepOpen
      />
      {selected && (
        <button
          className={s.clearFiltersButton}
          onClick={() => setSelectedTags([])}
        >
          <MLIcon className={s.xIcon} role="presentation" type="x" />
          <span>Clear Filters</span>
        </button>
      )}
    </div>
  );
}

export default TagsFilter;
